export default function LoadingProjectDetail() {
  return (
    <div className='container mx-auto'>
      <div className='animate-pulse flex space-x-4 my-4 h-80 rounded-md shadow bg-neutralColor-light border-2 border-gray-300'></div>
      <div className='animate-pulse w-11/12 mx-auto -mt-20 h-32 rounded-md shadow bg-gray-400'>
        <div className='flex w-full'>
          <div className='w-full'>
            <div className='h-4 bg-neutralColor-light w-1/3 m-5 rounded'></div>
            <div className='h-4 bg-neutralColor-light w-1/5 m-5 rounded'></div>
            <div className='h-4 bg-neutralColor-light w-1/4 m-5 rounded'></div>
          </div>
          <div className='p-5 w-full'>
            <div className='h-4 bg-neutralColor-light w-1/3 m-5 rounded'></div>
            <div className='h-4 bg-neutralColor-light w-1/5 m-5 rounded'></div>
          </div>
        </div>
      </div>
      <div className='w-full mx-auto mt-8'>
        <div className='animate-pulse flex flex-col lg:flex-row lg:space-x-4 my-4'>
          <div className='lg:w-1/4 space-y-4 py-1'>
            <div className='space-y-2'>
              <div className='h-48 bg-gray-400 rounded p-5'>
                <div className='h-4 bg-neutralColor-light w-1/2 mb-5 rounded'></div>
                <div className='h-4 bg-neutralColor-light w-1/3 mb-5 rounded'></div>
                <div className='h-4 bg-neutralColor-light w-1/2 rounded'></div>
              </div>
            </div>
          </div>
          <div className='lg:w-1/4 space-y-4 py-1'>
            <div className='space-y-2'>
              <div className='h-48 bg-gray-400 rounded p-5'>
                <div className='h-4 bg-neutralColor-light w-1/2 mb-5 rounded'></div>
                <div className='h-4 bg-neutralColor-light w-1/3 mb-5 rounded'></div>
                <div className='h-4 bg-neutralColor-light w-1/2 rounded'></div>
              </div>
            </div>
          </div>
          <div className='lg:w-1/4 space-y-4 py-1'>
            <div className='space-y-2'>
              <div className='h-48 bg-gray-400 rounded p-5'>
                <div className='h-4 bg-neutralColor-light w-1/2 mb-5 rounded'></div>
                <div className='h-4 bg-neutralColor-light w-1/3 mb-5 rounded'></div>
                <div className='h-4 bg-neutralColor-light w-1/2 rounded'></div>
              </div>
            </div>
          </div>
          <div className='lg:w-1/4 space-y-4 py-1'>
            <div className='space-y-2'>
              <div className='h-48 bg-gray-400 rounded p-5'>
                <div className='h-4 bg-neutralColor-light w-1/2 mb-5 rounded'></div>
                <div className='h-4 bg-neutralColor-light w-1/3 mb-5 rounded'></div>
                <div className='h-4 bg-neutralColor-light w-1/2 rounded'></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
